// extracted by mini-css-extract-plugin
module.exports = {"code":"dSIH_code___p9MT"};